export enum EventTypes {
  SORT,
  TABLE,
  SELECT,
  REORDER,
  TEXTBOXCHANGE,
  DRAGDROP,
  CLEAR,
  IMAGECLICK
}
